import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Document from "../../../custom/Document";
import KYCDoc from "./kycdoc";
import {API} from "../../../../config";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const investorUploads = API.service('investors-uploaded-files');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class SupportingDocs extends Component {
    state={
        poid:[],
        questions:false,
        aCount:0,
        all:false,
        action:'',
        answers:false,
        avatar:[],
    };

    getKYC = () => {
        const app = this;

        investorUploads.find({query:{_account:this.props.investor._account, _fieldname:this.props.document,$limit:1,$sort:{_creationdate:-1}}}).then(s=>{

            investorUploads.find({query:{_account:this.props.investor._account, _fieldname:'_avatar',$limit:1,$sort:{_creationdate:-1}}}).then(p=>{
                app.setState({
                    poid:s.data,
                    avatar:p.data
                })
            })
        })

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.investor._id !== this.props.investor._id) {
            const app = this;
            this.setState({
                poid:[],
                poad:[],
            },app.getKYC());
        }
    }

    componentDidMount() {
        this.getKYC()
    }

    onComplete = () => {
        const app = this;
        this.setState({
            poid:[],
            poad:[],
        },app.getKYC());
    }

    handleChange = (e) => {
        let fieldId= e.target.name.replace('question-','');
        let answers = this.state.answers;
        answers[fieldId] = e.target.value
        let all = true;
        //let action = (this.state.poid[0]._new_status ==='Requires Attention') ? 'accept' : 'approve';
        let action = 'accept';
        if(this.state.poid[0]._new_status ==='Accepted'){
            action = 'approve'
        }

        if(this.state.poid[0]._new_status ==='Approved'){
            action = 'approve'
        }

        Object.keys(answers).forEach(k=>{
            console.log(k,answers[k]);
            if(answers[k] === ''){
                all = false;
            }

            if(answers[k] !== 'yes'){
                action = 'decline';
            }
        })

        console.log(all);

        this.setState({
            answers,
            all,
            action
        })
    }

    trigger = () => {
        this.props.updateState(this.state.answers, this.props.document, this.state.poid[0]._id, this.state.poid[0]._new_status, this.state.action)
    }

    render() {
        return (
            <React.Fragment>
                <div className={'flex'}>
                    <Paper className={'flex-1 mr-1'} style={{position:'relative', margin:5}}>

                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    {this.props.documentTitle}
                                </Typography>
                                <Document hideImage={true} investor={this.props.investor._account} type={this.props.document} label={this.props.documentTitle}
                                          placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} onComplete={()=>this.onComplete()}/>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">

                        {this.state.poid.map((v,i)=>{
                            return (<React.Fragment>
                                <KYCDoc data={v} key={i} />
                            </React.Fragment>)
                        })}
                        </div>
                    </Paper>

                    <Paper className={'flex-1 mr-1'} style={{position: 'relative', margin: 5}}>
                        <AppBar position="static" elevation={0} color={"default"} style={{boxShadow: 'none'}}>
                            <Toolbar>
                                <Typography variant="title" color="inherit" className={"flex-1"}>
                                    Profile Picture
                                </Typography>
                                <Document hideImage={true} investor={this.props.investor._account} type={'_avatar'} label={'Avatar'}
                                          placeholder='/assets/images/profile/default_photo.jpg' hideReviewStatus={true} onComplete={()=>this.onComplete()}/>
                            </Toolbar>
                        </AppBar>
                        <div className="p-12">

                            {this.state.avatar.map((v,i)=>{
                                return (<React.Fragment>
                                    <KYCDoc data={v} key={i} />
                                </React.Fragment>)
                            })}
                        </div>
                    </Paper>

                </div>
            </React.Fragment>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(SupportingDocs)));
